<template>
	<page class="dashboard" title="Aktivitet" style="background-color: #F0F0F0;">
		<input class="tool-text" placeholder="Emne" type="text" slot="tools" v-model="topic" />
		<new-table-view class="list" @itemClick="itemClick" :columns="[
			{
				label: 'Modtaget',
				name: 'created',
				filter: 'timestamp_s'
			},
			{
				label: 'Afsender',
				name: ['_computed', 'client', ]
			},
			{
				label: 'Emne',
				name: 'topic'
			},
			{
				label: 'Payload',
				name: 'payload',
				weight: '2fr'
			},
			{
				label: '',
				name: 'resend',
				align: 'right',
				template: {
					name: 'button',
					label: 'Gensend'
				}
			}
		]" :items="_items" @resend="itemResend" />
	</page>
</template>

<script>
	import { bus } from '../../bus'

	import activity from '../model/activity';

    export default {
		data() {
			return {
				items: [],
				topic: ''
			};
		},
		components: {

		},
		watch: {
			topic() {
				this.update();
			}
		},
		computed: {
			_items() {
				return this.items;
			}
		},
		methods: {
			async itemResend(item, event) {
				event.stopPropagation();
				console.log('item resend', item);

				await this.axios.post('/publish', {
					topic: item.topic,
					payload: item.payload
				});

				this.update();
			},
			itemContext(item, event) {
				/*event.stopPropagation();

				var self = this;

				var actions = [];

				if (item.type == 'survey') {
					actions.push({
						label: 'Print privat',
						action: async function () {
							window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/private/print/?token=' + self.$store.state.auth);
						}
					});

					actions.push({	
						label: 'Print erhverv',
						action: async function () {
							window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/business/print/?token=' + self.$store.state.auth);
						}
					});

					actions.push(null);
				}

				actions.push({
					label: 'Slet',
					action: async function () {
						if (await TaskModel.delete(self.axios, item.id)) {
							self.update();
						}
					}
				});

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: actions
				});*/
			},
			async itemClick(item) {
				console.log('item click', item);

				activity.window(item);
			},
			async update() {
				this.items = (await this.axios.get("/activities/search", {
					params: {
						topic: this.topic
					}
				})).data;
			}
		},
		mounted() {
			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.tool-text {
		display: block;
		float: left;
		margin-left: 10px;
		height: 40px;
		border-radius: 20px;
		padding-left: 20px;
		border: 1px solid #cecece;
	}

	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 290px 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		padding: 30px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 2 / 3;
		background-color: #f0f0f0;		
	}

	.list {
		width: 100%;
		height: 100%;
		border-left: 1px solid #cecece;
		background-color: white;
	}
</style>